// extracted by mini-css-extract-plugin
export default {"contentContainer":"MyLevel_contentContainer__vf8-b"};